import ENGLISH_TRANSLATIONS from './EnglishTranslations';
import POLISH_TRANSLATIONS from './PolishTranslations';
import GERMAN_TRANSLATIONS from './GermanTranslations';

export default {
  en: ENGLISH_TRANSLATIONS,
  pl: POLISH_TRANSLATIONS,
  de: GERMAN_TRANSLATIONS
};
